/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react';
import { InboxEntity } from '../types';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';

interface State {
  readonly data?: string;
  readonly error?: DataAPIClientError;
  readonly isProcessing: boolean;
}

interface Result extends State {
  readonly invoke: (inbox: InboxEntity) => Promise<void>;
}

export default function useDataAPIDeactivateInbox(): Result {
  const client = useDataAPIClient();
  const [state, setState] = useState<State>({ isProcessing: false });

  async function invoke(inbox: InboxEntity): Promise<void> {
    setState({ isProcessing: true });

    try {
      const data = await client.deactivateInbox(inbox);

      setState({ data, isProcessing: false });
    } catch (error: any) {
      setState({ error, isProcessing: false });
    }
  }

  return { ...state, invoke };
}
